"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarkBaseApi = void 0;
var tslib_1 = require("tslib");
var client_command_1 = require("../base/commands/client-command");
var command_base_1 = require("../base/commands/command-base");
var bookmark_1 = require("../model-api/bookmark");
var BookmarkBaseApi = (function (_super) {
    tslib_1.__extends(BookmarkBaseApi, _super);
    function BookmarkBaseApi(core, subDocument, bookmark) {
        var _this = _super.call(this, core, subDocument, bookmark) || this;
        _this._core = core;
        return _this;
    }
    BookmarkBaseApi.prototype.goTo = function () {
        var command = this._core.commandManager.getCommand(client_command_1.RichEditClientCommand.GoToBookmark);
        var options = new command_base_1.CommandSimpleOptions(this._core, this._bookmark.name);
        command.execute(true, options);
    };
    return BookmarkBaseApi;
}(bookmark_1.BookmarkApi));
exports.BookmarkBaseApi = BookmarkBaseApi;
